module.exports = __webpack_public_path__ + "img/book-lesson.54742cd8.svg";